export const getPattern = (num) => {
  var nums = getNumbers(num),
    ranNums = [],
    i = nums.length,
    j = 0;

  while (i--) {
    j = Math.floor(Math.random() * (i + 1));
    ranNums.push(nums[j]);
    nums.splice(j, 1);
  }
  return ranNums;
};

export const getNumbers = (num) => {
  let i = 0;
  let arr = [];
  while (i < num) {
    arr.push(i);
    i += 1;
  }
  return arr;
};

export const getRandDirection = () => {
  let items = ["up", "down", "right", "left"];
  return items[Math.floor(Math.random() * items.length)];
};

export function getRotationAngle(target) {
  const obj = window.getComputedStyle(target, null);
  const matrix =
    obj.getPropertyValue("-webkit-transform") ||
    obj.getPropertyValue("-moz-transform") ||
    obj.getPropertyValue("-ms-transform") ||
    obj.getPropertyValue("-o-transform") ||
    obj.getPropertyValue("transform");

  let angle = 0;

  if (matrix !== "none") {
    const values = matrix.split("(")[1].split(")")[0].split(",");
    const a = values[0];
    const b = values[1];
    angle = Math.round(Math.atan2(b, a) * (180 / Math.PI));
  }

  return angle < 0 ? (angle += 360) : angle;
}
